export function mapGetCollectionsToResponse(collections: any): any {
  // Handle both nodes and edges patterns for backward compatibility
  const collectionList =
    collections?.nodes ||
    collections?.edges?.map((edge: any) => edge.node) ||
    [];

  return collectionList;
}

export function mapGetCollectionToResponse(collection: any): any {
  // Handle both nodes and edges patterns for backward compatibility
  if (!collection) {
    return null;
  }

  // Get products with backward compatibility
  const products =
    collection.products?.nodes ||
    collection.products?.edges?.map((edge: any) => edge.node) ||
    [];

  // Process each product to handle nested nodes/edges patterns
  const processedProducts = products.map((product: any) => ({
    ...product,
    // Handle variants nodes/edges conversion
    variants:
      product.variants?.nodes ||
      product.variants?.edges?.map((edge: any) => edge.node) ||
      [],
    // Handle images nodes/edges conversion
    images:
      product.images?.nodes ||
      product.images?.edges?.map((edge: any) => edge.node) ||
      [],
  }));

  return {
    ...collection,
    products: processedProducts,
  };
}
